import { createSlice, nanoid } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    toastsEnabled: true, // Toast notifications enabled by default
  },
  reducers: {
    addNotification: {
      reducer: (state, action) => {
        // Add a unique ID to each notification
        // and ensure we don't add duplicate messages if not intended
        if (!state.notifications.some(n => n.message === action.payload.message && n.type === action.payload.type)) {
            state.notifications.push(action.payload);
        }
      },
      prepare: (notification) => {
        const id = nanoid();
        return { payload: { id, ...notification } };
      },
    },
    dismissNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    toggleToasts: (state) => {
      state.toastsEnabled = !state.toastsEnabled;
    },
  },
});

export const { addNotification, dismissNotification, clearNotifications, toggleToasts } = notificationSlice.actions;

export default notificationSlice.reducer;
